<template>
   <div>
       <div class='video_box'>
           <div class='video_mask'>
                <Icon @click="$emit('uploadsuccess','')" class='video_icon video_trash' size="20" type="trash-a"></Icon>
                <Icon class='video_icon video_edit' size="20" type="edit"></Icon>    
            </div>
            <input class="video_edit_input" type="file" accept="video/*"  @change="getvideo($event)"/>
           <video class="video" v-if='video' :src='imgUrl+video'></video>
       </div>
        <div class="upload" v-if='!video'>
            <Icon class="upload_icon" type="camera" size="20"></Icon>
            <input class="upload_input" type="file" accept="video/*"  @change="getvideo($event)"/>
        </div>                 
   </div>
</template>

<script>
    import matterManageApi from "@/api/matterManage";

   export default {
       data() { 
           return {
               videoSzie:'',
           }
       },
       props: ['video'],
       mounted() {

       },
       methods:{
            async getvideo(e){
                let formdata= new FormData();
                formdata.append('video',e.target.files[0])
                let res =await matterManageApi.addVideo(e.target.files[0].size,formdata);
                if(res.data.code=='200'){
                    this.$Message.success('操作成功')
                    this.$emit('uploadsuccess',res.data.data)
                }else{
                    this.$Message.error(res.data.message)
                }
            },
       },
   }
</script>

<style scoped>
.upload{
    width: 100px;
    height: 100px;
    border-radius:3px;
    border: 1px dashed #dddee1;
    line-height: 100px;
    position: relative;
}
.upload:hover{
    border: 1px dashed #6236FF;
}
.upload_icon{
    margin-left: 40px;
}
.upload_input{
    width: 100px;
    height: 100px;
    opacity: 0;
    position: absolute;
    left: 0;
    top: 0;
}

.video_box{
    width: 150px;
    position:relative;
}
.video{
    width:100%;
}
.video_mask{
    width:100%;
    height:100%;
    position:absolute;
    left:0;
    top:0;
    background:rgba(0,0,0,0.6);
    z-index:2
}

.video_icon{
    position:absolute;
    top:0;
    bottom:0;
    margin:auto;
    color:#fff;
    height:20px;
    display:none;
}
.video_mask:hover .video_icon{
    display:inline-block;
}
.video_trash{
    left:50px
}
.video_edit{
    right:50px;
}
.video_edit_input{
    position:absolute;
    right:30px;
    height:40px;
    width:40px;
    opacity:0;
    top:0;
    bottom:0;
    margin:auto;
    z-index:3
}
</style>